<template>
  <div class="activity-wrap">
    <app-header />
    <span class="btn-rule" @click="isPopRule = true">活动规则</span>
    <div class="auto">
      <span class="btn-buy" @click="activate()">立即激活></span>
      <div class="mod">
        <div class="mod-con">
          <h2 class="title title1"></h2>
          <h3><span>超级Level2</span></h3>
          <p class="summary">千万股民口碑之选——千档行情、全息盘口，主力控盘区域一目了然</p>
          <img src="../../assets/images/activity/202403/img4-1.jpg" alt="">
          <div class="text">
            <p>Level2超级盘口对于分析盘中买卖盘、盘后复盘有极其重要的作用。</p>
            <p>千档盘口让你看到别人看不到的行情，一眼看穿主力大资金潜伏价位。</p>
            <p>全息盘口完美展示个股每一笔的成交情况，是盘中跟踪、盘后复盘利器。</p>
          </div>
          <h3><span>波段线</span></h3>
          <p class="summary">
            <span><em>L</em>点：关注信号</span>
            <span><em>B</em>点：反转信号</span>
            <span><em>D</em>点：风险信号</span>
            <span><em>S</em>点：避险信号</span>
          </p>
          <img src="../../assets/images/activity/202403/img4-2.jpg" alt="">
          <h3 class="mt50"><span>热钱追踪</span></h3>
          <p class="summary">DDE当日资金流排序功能，助力投资者紧跟热钱的脚步</p>
          <img src="../../assets/images/activity/202403/img4-3.jpg" alt="">
        </div>
      </div>
      <div class="mod">
        <div class="mod-con">
          <h2 class="title title2"></h2>
          <img src="../../assets/images/activity/202403/img4-4.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="mod-footer">
      <div class="footer-con">
        <div class="tel">
          <p><img src="../../assets/images/activity/202403/icon-tel.png" alt="">免费服务热线: 021-20219997</p>
          <p><img src="../../assets/images/activity/202403/icon-time.png" alt="">周一至周五08:30-17:30</p>
        </div>
        <p class="tips">风险提示:本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议，数据基于历史，不代表未来趋势，所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险入市需谨慎。</p>
      </div>
    </div>
    <div class="pop-rule" v-show="isPopRule" @click="isPopRule = false">
      <div class="rule-con" @click.stop="isPopRule = true">
        <p>1、活动期间，领取权益后需要当月激活，领取链接当月有效，过期则权益作废。</p>
        <p>2、活动期间，符合条件的用户均可以免费领取电脑端大智慧365一个月的使用特权。</p>
        <p>3、活动期间，凡以不正当手段(如恶意刷单、作弊、扰乱系统、实施网络攻击等)参与本次活动的用户，大智慧有权终止其参与活动并回收所有产品体验权;如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整、活动中存在大面积作弊行为、活动遭遇严重网络攻击或系统故障导致活动不能正常进行)的影响，大智慧保留在法律规定范围内对上述规则进行解释的权利。</p>
        <p>4、关于活动任何问题，可在工作日8:30-17:30通过以下方式联系客服；全国统一服务热线:021-20219997。</p>
        <p>5、此活动归属权归大智慧所有。</p>
      </div>
    </div>
    <div class="pop-success" v-show="isSuccess">
      <h2>{{ this.activateMsg1 }}</h2>
      <p>{{ this.activateMsg2 }}</p>
      <span class="btn" @click="isSuccess = false">好的</span>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      isPopRule: false,
      isSuccess: false,
      activateMsg1:"激活成功",
      activateMsg2: "快去使用吧~",
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    activate(){
      this.$post("/user/free365Activate")
        .then(response => {
          if (response.code === 0) {
            var businessCode = response.data;
            if(businessCode == 0 || businessCode == 622){
              this.isSuccess = true;
            }else{
              this.isSuccess = true;
              this.activateMsg1 = "激活失败";
              if(businessCode == 619){
                this.activateMsg2 = "您暂不符合活动要求";
              }else if(businessCode == 620){
                this.activateMsg2 = "您已领取过活动福利";
              }else if(businessCode == 621){
                this.activateMsg2 = "本次活动已经结束";
              }else if(businessCode == 623){
                this.activateMsg2 = "活动名额已用尽";
              }else{
                this.activateMsg2 = "激活失败";
              }
            }
          }else{
            this.isSuccess = true;
            this.activateMsg1 = "激活失败";
            this.activateMsg2 = response.msg;
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    }
  }
}
</script>
<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background: url(../../assets/images/activity/202403/bg4.jpg) no-repeat center 100px #feeddb;
  .auto{
    width: 1050px;
    margin: 0px auto 0px;
    position: relative;
    padding-top: 407px;
  }
  .btn-buy{
    width: 315px;
    height: 85px;
    box-shadow: 0 5px 20px #ff9287;
    background: linear-gradient(to bottom, #e67158, #e64b3b);
    display: block;
    border-radius: 15px;
    color: #fff;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
    line-height: 85px;
    margin-bottom: 237px;
    cursor: pointer;
  }
  .btn-rule{
    display: block;
    width: 56px;
    height: 153px;
    border-radius: 20px 0 0 20px;
    background-image: linear-gradient(to bottom, #fff4aa, #ffea3c);
    border: 1px solid #fff;
    box-shadow: 0 6px 9px rgba($color: #f28234, $alpha: 0.59);
    font-size: 30px;
    color: #c42b25;
    line-height: 1.1;
    text-align: center;
    padding-top: 10px;
    position: absolute;
    top: 176px;
    right: 0;
    cursor: pointer;
  }
  .mod{
    background: #ffe9ce;
    box-shadow: 0 0 10px #e4a06e;
    border-radius: 20px;
    padding: 14px;
    border: 1px solid #fff;
    width: 900px;
    margin: 0 auto 77px;
    .mod-con{
      box-shadow: 0 0 10px #e4a06e;
      background: #fff;
      position: relative;
      padding: 84px 28px 40px;
      border-radius: 15px;
    }
    .title{
      @include center-box-x();
      top: -39px;
    }
    .title1{
      background: url(../../assets/images/activity/202403/title5-1.png);
      width: 402px;
      height: 98px;
    }
    .title2{
      background: url(../../assets/images/activity/202403/title5-2.png);
      width: 744px;
      height: 98px;
    }
    h3{
      color: #442a13;
      font-size: 36px;
      &.mt50{
        margin-top: 50px;
      }
      span{
        position: relative;
        z-index: 1;
        font-weight: bold;
        &:before{
          content: '';
          display: block;
          position: absolute;
          left: 0;
          bottom: 2px;
          width: 110%;
          background: #fcecd3;
          height: 10px;
          z-index: -1;
        }
      }
    }
    .summary{
      color: #442a13;
      font-size: 30px;
      margin: 15px 0 20px;
      display: flex;
      flex-wrap: wrap;
      em{
        font-weight: bold;
      }
      span{
        width: 33%;
        line-height: 1;
        &:last-child{
          margin: 22px 0 10px;
        }
      }
    }
    .text{
      display: flex;
      justify-content: center;
      margin: 37px 0 78px;
      p{
        width: 235px;
        padding: 30px 25px;
        border-radius: 70px 20px 70px 20px;
        background: linear-gradient(to right, #fde9ce, #fddcae);
        font-size: 26px;
        color: #432813;
        line-height: 1.6;
        +p{
          margin-left: 35px;
        }
      }
    }
  }
  .mod-footer{
    background: #fed39e;
    padding: 40px 0;
    .footer-con{
      width: 900px;
      margin: 0 auto;
    }
    .tel{
      display: flex;
      p{
        width: 50%;
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #5b3c1e;
        img{
          margin-right: 10px;
        }
      }
    }
    .tips{
      font-size: 16px;
      color: #78593a;
      margin-top: 18px;
      line-height: 24px;
    }
  }
  .pop-rule{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 20;
    .rule-con{
      background: url(../../assets/images/activity/202403/pop-bg4.png) no-repeat;
      width: 967px;
      height: 564px;
      @include center();
      padding: 115px 45px 0px;
      font-size: 24px;
      color: #a9690f;
      p{
        margin-bottom: 3px;
        line-height: 36px;
      }
    }
  }
  .pop-success{
    background: url(../../assets/images/activity/202403/pop-bg5.png) no-repeat;
    width: 442px;
    height: 440px;
    @include center();
    padding-top: 214px;
    text-align: center;
    h2{
      color: #262626;
      font-size: 38px;
      font-weight: bold;
    }
    p{
      color: #262626;
      font-size: 20px;
      margin: 12px 0 40px;
    }
    .btn{
      width: 282px;
      height: 60px;
      line-height: 60px;
      color: #fff;
      font-size: 26px;
      font-weight: bold;
      background: linear-gradient(to right, #fd8b45, #fc362e);
      display: block;
      margin: 0 auto;
      border-radius: 30px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity20240303.vue